import React from 'react'
import SalesSummaryCards from './components/SalesSummaryCards'
import SellThroughSegments from './components/SellThroughSegments'
import GrcTransactionSection from './components/GrcTransactionSection'
import TopSellingDesigns from './components/TopSellingDesigns'
import SalesTrendsCard from './components/SalesTrendsCard'
import CategoryContributionCard from './components/CategoryContributionCard'
import PoAmountQtyCard from './components/PoAmountQtyCard'
import CashFlowLadderCard from './components/CashFlowLadderCard'
import EarlyPaymentRequestCard from './components/EarlyPaymentRequestCard'

// Business Dashboard tab of the vendor dashboard module. Every card fetches its own data from
// the business summary apis; businessDashboardConstants only holds presentation config now.
function BusinessDashboard() {
    return (
        <div className='business-dashboard pl-[27px] pr-[12px] pt-[12px] pb-[15px] flex flex-col gap-[12px] text-fontBlack'>

            {/* Sales summary */}
            <SalesSummaryCards />

            <SellThroughSegments />

            <GrcTransactionSection />

            <TopSellingDesigns />

            {/* The wide charts sit on the left, the receivables column on the right */}
            <div className='flex flex-col xl:flex-row items-start gap-[12px]'>
                <div className='flex-1 min-w-0 w-full flex flex-col gap-[12px]'>
                    <SalesTrendsCard />
                    <CategoryContributionCard />
                    <PoAmountQtyCard />
                </div>

                <div className='w-full xl:w-[469px] shrink-0 flex flex-col gap-[12px]'>
                    <CashFlowLadderCard />
                    <EarlyPaymentRequestCard />
                </div>
            </div>
        </div>
    )
}

export default BusinessDashboard
